import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Grid from "@material-ui/core/Grid";
import withStyles from "components/with-styles";
import styles from "./styles/data-grid-item.css.js";

const DataGridItem = ({
  children,
  classes,
  big,
  half,
  small,
  extraSmall,
  threeQuarter,
  centered,
  className,
  sizesOverride = {},
  container = false,
  ...props
}) => {
  let sizes = { xl: container ? 6 : 3, lg: 6, md: 6, sm: 6, xs: 12 };
  if (big) {
    sizes = { xl: 12, lg: 12, md: 12, sm: 12, xs: 12 };
  }
  if (threeQuarter) {
    sizes = { xl: 9, lg: 9, md: 9, sm: 12, xs: 12 };
  }
  if (half) {
    sizes = { xl: 6, lg: 6, md: 6, sm: 12, xs: 12 };
  }
  if (small) {
    sizes = { xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
  }
  if (extraSmall) {
    sizes = { xl: 2, lg: 2, md: 2, sm: 12, xs: 12 };
  }

  return (
    <Grid
      className={cn(className, classes.datagrid_item, centered && classes.datagrid_item__centered)}
      item
      {...sizes}
      {...sizesOverride}
      {...props}
    >
      {children}
    </Grid>
  );
};

DataGridItem.propTypes = {
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Indica si el item utiliza los estilos de máximo ancho
   */
  big: PropTypes.bool,
  /**
   * Indica si el item utiliza estilos para mostrarlo más pequeño
   */
  small: PropTypes.bool,
  /**
   * Indica si el item utiliza estilos para mostrarlo en 3/4 del ancho del grid
   */
  threeQuarter: PropTypes.bool,
  /**
   * Indica si el contenido está centrado horizontalmente
   */
  centered: PropTypes.bool,
  /**
   * Objeto que reemplaza los tamaños por defecto
   */
  sizesOverride: PropTypes.object,
  /**
   * Indica si el grid tiene contenido grande y ocupa más espacio en pantallas grandes
   */
  container: PropTypes.bool,
};

export default withStyles(styles)(DataGridItem);
